import { v4 as uuidv4 } from 'uuid'
import { CalculationTableHeaderCellSize } from 'src/components/atoms'
import { Cell as Column } from 'src/components/molecules/CalculationTableHeaderRow'
import { EditReadItem } from 'src/slices/editCalculations/editCalculationsSlice'
import { CalculationDSL, CalculationItem } from 'src/slices/services/api'
import { injectIndex } from 'src/utils/array'
import { Cell as InputCell } from '../components/EditReadItemBodyRow'
import { BodyRow } from '../components/EditReadItemTable'

interface EditReadItemFunctionsIf {
  columns(addCellCount?: number): Column[]
  rows(calculationItems: CalculationItem[]): BodyRow[]
  getInputCellName(rowIndex: number, cellIndex: number): string
  convertDSLToForm(dsls: CalculationDSL[]): EditReadItem[]
}

export const defaultColumnLength = 5

const addColumns = (count: number): Column[] => {
  const baseColumn = (index: number) => {
    return {
      index,
      text: '',
      size: 'large' as CalculationTableHeaderCellSize,
    }
  }

  return new Array<Column | null>(count)
    .fill(null)
    .map((_, i) => baseColumn(i + defaultColumnLength))
}

const baseColumns = (addCellCount = 0): Column[] => {
  const base = [
    {
      text: 'No.',
      size: 'medium' as CalculationTableHeaderCellSize,
    },
    {
      text: '算出項目名',
      size: 'large' as CalculationTableHeaderCellSize,
    },
    {
      text: '',
      size: 'small' as CalculationTableHeaderCellSize,
    },
    {
      text: '対応項目',
      size: 'large' as CalculationTableHeaderCellSize,
    },
    {
      text: '',
      size: 'large' as CalculationTableHeaderCellSize,
    },
  ]
  return injectIndex([...base, ...addColumns(addCellCount)])
}

export const editReadItemCell = (name: string): InputCell => {
  return {
    name,
    placeholder: '対応するレシートの項目を入力',
  }
}

const baseRows = (calculationItems: CalculationItem[]): BodyRow[] => {
  return calculationItems.map((item, rowIndex) => {
    const name = `rows.${rowIndex}.0`
    return {
      title: item.name,
      // フィルタリング後の連番で表示（rowIndex + 1）
      number: String(rowIndex + 1),
      cells: [editReadItemCell(name)],
      disabledRow: item.fixedDsl !== null && item.fixedDsl !== undefined,
    }
  })
}

const EditReadItemFunctions: EditReadItemFunctionsIf = {
  columns(addCellCount?: number): Column[] {
    return baseColumns(addCellCount)
  },
  rows(calculationItems: CalculationItem[]): BodyRow[] {
    return baseRows(calculationItems)
  },
  getInputCellName(rowIndex: number, cellIndex: number): string {
    return `rows.${rowIndex}.${cellIndex}`
  },
  convertDSLToForm(dsls) {
    if (dsls.length === 0) return []

    return dsls.flatMap((current, dslIndex) => {
      if (!current.ocrFormats) return []
      // fixedDsl がある calculationItem は input が disabled なので、default value を入れる必要がない
      if (current.calculationItem.fixedDsl) return []

      return current.ocrFormats.map((format) => ({
        id: uuidv4(),
        readItem: format.readItem,
        calculationId: current.calculationItem.id,
        // フィルタリング後の配列内インデックスを使用（baseRowsのrowIndexと対応させるため）
        calculationIndex: dslIndex,
      }))
    })
  },
}

export default EditReadItemFunctions
